import { render } from "./LargeButton.vue?vue&type=template&id=15452444&ts=true"
import script from "./LargeButton.vue?vue&type=script&lang=ts"
export * from "./LargeButton.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src903112286/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__